import clsx from 'clsx';
import styles from './ActivityListItem.module.css';
import { IoIosArrowForward } from 'react-icons/io';

export default function ActivityListItem({
  label,
  icon,
  isActive,
  onClick,
  notificationCount,
  color = 'var(--Primary_Color)', // can be hex, var, or named
}) {
  return (
    <div
      className={clsx(styles.item, isActive && styles.active)}
      style={{ "--base-color": color }}
      onClick={onClick}
    >
      <div className={styles.LeftContainer}>
        {icon && <div className={styles.iconWrapper}>{icon}</div>}
        <span className={styles.label}>{label}</span>
      </div>

      <div className={styles.RightContainer}>
        {notificationCount && <span className={styles.notificationCount}>{notificationCount}</span>}
        <IoIosArrowForward className={styles.arrow} />
      </div>
    </div>
  );
}
